module.exports = __webpack_public_path__ + "files/449a300dd78115b7926766f670ce651e.png";